import Survey from "./Survey";
import Electronic_sharing from "./Electronic_sharing";
import Consultation from "./Consultation";
import Home from "./home1"
import FAQS from "./FAQS1"
import Conditions from "./conditions"
import CustomerCharter from "./CustomerCharter"
import Error from "./Error1"
import Acareer from "./Acareer";
import Feedback from "./FeedbackI"
import Feedbacksec from "./Feedbacksec"
import Contactus from "./Contactus1"
import Career from "./career1"
import Mobilenavbar from "./Mobilenavbar1"
import Header from "./Header1";
import useAutoResize from './useAutoResize'

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

function App() {
    useAutoResize();

    return (
        <>
            <div>

                <Routes>
                    <Route path="/" element={<CustomerCharter />}/> 
                    {/* <Route path="/" element={<Electronic_sharing />} /> 
                    <Route path="/" element={<Electronic_sharing />} /> */}
                    {/* <Route path="/" element={<Consultation />} /> 

                    <Route path="/" element={<Home />} />
                    <Route path="/Electronic_sharing" element={<Electronic_sharing />} />
                    <Route path="/FAQS" element={<FAQS />} />
                    <Route path="/conditions" element={<Conditions />} />
                    <Route path="/CustomerCharter" element={<CustomerCharter />} />
                    <Route path="/Error" element={<Error />} />
                    <Route path="/Consultation" element={<Consultation />} />
                    <Route path="/Survey" element={<Survey />} />
                    <Route path="/Acareer" element={<Acareer />} />
                    <Route path="/Feedback" element={<Feedback />} />
                    <Route path="/Feedbacksec" element={<Feedbacksec />} />
                    <Route path="/Contactus" element={<Contactus />} />
                    <Route path="/Career" element={<Career />} />
                    <Route path="/Mobilenavbar" element={<Mobilenavbar />} />
                    <Route path="Header" element={<Header />} />*/}
                </Routes>


            </div>


        </>

    );


}

export default App;
